export const adminType = Object.freeze({"endUser":0, "administrator":1, "producer":2, "technician": 3})